export type MagicMomentToken = string | { id: string; placeholder: string };

export const MAGIC_MOMENT_FEMALE_TOKENS: readonly MagicMomentToken[] = [
  "hiii! been thinking about ",
  { id: "thing", placeholder: "specific thing from your convo" },
  " and ",
  { id: "why", placeholder: "why it stuck with you" },
  ". feeling really lucky i got matched as ur mentor. ",
  { id: "compliment", placeholder: "give them a genuine compliment" },
  " so excited to keep getting to know each other!",
];

export const MAGIC_MOMENT_MALE_TOKENS: readonly MagicMomentToken[] = [
  "yooo! been thinking about what u said about ",
  { id: "thing", placeholder: "specific thing" },
  " and ",
  { id: "why", placeholder: "why it stuck with you" },
  ". honestly feeling lucky i got matched as ur mentor. ",
  { id: "compliment", placeholder: "give them a genuine compliment" },
  " excited to keep getting to know u!",
];

export function getMagicMomentTokens(
  teenGender: "male" | "female" | null,
): readonly MagicMomentToken[] {
  return teenGender === "male"
    ? MAGIC_MOMENT_MALE_TOKENS
    : MAGIC_MOMENT_FEMALE_TOKENS;
}

export function buildMagicMomentMessage(
  tokens: readonly MagicMomentToken[],
  values: Record<string, string>,
): string {
  return tokens
    .map((token) => {
      if (typeof token === "string") return token;
      const value = values[token.id]?.trim();
      return value && value.length > 0 ? value : `[${token.placeholder}]`;
    })
    .join("");
}
